import { createFileRoute, redirect } from '@tanstack/react-router'

// The reports index page was removed — reports now live as an expandable
// «Звіти» group in the sidebar (see Sidebar §reportsGroup). `/reports/` is
// kept as a redirect to the first report so old bookmarks / breadcrumbs stay
// alive, matching the stock-balances / material-consumption legacy routes.
export const Route = createFileRoute('/_app/reports/')({
  beforeLoad: () => {
    throw redirect({ to: '/reports/stock-movements/' })
  },
})
